module.exports = __webpack_public_path__ + "img/g_duoyun.540040bc.png";